import '../../components/DataTableV2Rows.css';
import './Thresholds.css';
export var dataTableV2HasPillThresholdsCSS = '_qofu3c2-2-0-1';
export var dataTableV2HasThresholdsCSS = '_qofu3c1-2-0-1';
export var dataTableV2ThresholdPillColor = 'var(--_qofu3c0-2-0-1)';
export var thresholdPillCSS = '_qofu3c3-2-0-1';